











import { mapGetters } from 'vuex';
import Vue from 'vue'

export default Vue.extend({

	components: {
	},

	data() {
		return {
		}
	},

	computed: {
		...mapGetters("alert", ["currentMessage"])
	},

	methods: {
		close() {
			this.$store.commit("alert/popMessage");
		}
	},

	watch: {
		currentMessage(message) {
			if(message){
				Vue.nextTick(() => {
					(this.$refs.btn as HTMLButtonElement).focus();
				})
			}

		}
	}
})
